import { SegmentGroup } from "@ttc3k/trekker";
import { OperatorTabsEnum } from "apps/directory/shared.ts";
import { useTranslation } from "react-i18next";
import { useLoggedInAs } from "shared/hooks";
import { getOperatorTabsConfig } from "./getOperatorTabsConfig";

interface OperatorTabsProps {
  currentTab: string;
  onTabChange: (value: OperatorTabsEnum) => void;
}

export const OperatorTabs = ({
  currentTab,
  onTabChange,
}: OperatorTabsProps) => {
  const { t } = useTranslation();
  const loggedInAs = useLoggedInAs();

  const operatorTabsConfig = getOperatorTabsConfig(t, loggedInAs);
  return (
    <SegmentGroup.Root
      orientation={"horizontal"}
      value={currentTab}
      onValueChange={(v) => onTabChange(v.value as OperatorTabsEnum)}
    >
      {operatorTabsConfig.map((operatorTab) => (
        <SegmentGroup.Item value={operatorTab.value} key={operatorTab.value}>
          <span>{operatorTab.title}</span>
        </SegmentGroup.Item>
      ))}
    </SegmentGroup.Root>
  );
};
